export const SET_DIALOG_IS_OPEN = "SET_DIALOG_IS_OPEN";
export const SET_SELECTED_DASHBOARD = "SET_SELECTED_DASHBOARD";
